export default "__VITE_ASSET__b92e33cd__"